import { getLocalizedMonthNames } from 'utils/date';

const getHighcharts = () => window.Highcharts;

getHighcharts().setOptions({
  lang: {
    months: getLocalizedMonthNames(),
    shortMonths: getLocalizedMonthNames('abbreviated'),
    weekDays: [
      'zondag',
      'maandag',
      'dinsdag',
      'woensdag',
      'donderdag',
      'vrijdag',
      'zaterdag'
    ]
  }
});

export default window.Highcharts;
